@if (state$ | async; as state) {
    <div
        class="options-overlay fixed top-0 left-0 right-0 bottom-0"
        [class.opacity-0]="!state.open"
        [class.opacity-100]="state.open"
        [class.pointer-events-none]="!state.open"
        [class.pointer-events-auto]="state.open"
        (click)="close()"></div>
    <div
        class="options-panel fixed bottom-0 left-0 w-full flex flex-column border-round-top-xl"
        [class.translate-y-100]="!state.open"
        [class.translate-y-0]="state.open">
        <div
            class="panel-header flex align-items-center justify-content-between flex-shrink-0">
            <span class="panel-title">{{ state.title }}</span>
            <button
                class="panel-close flex align-items-center justify-content-center p-0 border-none bg-transparent cursor-pointer"
                (click)="close()"
                aria-label="Close">
                <i class="pi pi-times"></i>
            </button>
        </div>
        <ul class="panel-options m-0 p-0 list-none overflow-y-auto min-h-0">
            @for (item of state.items; track item.label) {
                <li>
                    @if (item.link !== undefined) {
                        <a
                            class="flex align-items-center justify-content-start w-full bg-transparent border-none no-underline cursor-pointer"
                            [routerLink]="item.link"
                            [queryParams]="item.queryParams"
                            (click)="close()">
                            <ng-container
                                *ngTemplateOutlet="
                                    optionContent;
                                    context: { $implicit: item }
                                "></ng-container>
                        </a>
                    } @else {
                        <button
                            class="flex align-items-center justify-content-start w-full bg-transparent border-none cursor-pointer"
                            (click)="invoke(item)">
                            <ng-container
                                *ngTemplateOutlet="
                                    optionContent;
                                    context: { $implicit: item }
                                "></ng-container>
                        </button>
                    }
                </li>
            }
        </ul>
    </div>
}

<ng-template #optionContent let-item>
    @if (item.active !== undefined) {
        <span
            class="option-marker flex-shrink-0 border-circle"
            [class.option-marker--active]="item.active"></span>
    }
    @if (item.iconName) {
        <app-custom-icon
            class="flex-shrink-0"
            [iconPath]="'assets/icons/general-icons.svg'"
            [imageName]="item.iconName"
            [imageSize]="item.imageSize || '24'">
        </app-custom-icon>
    }
    <h6 class="m-0 p-0">{{ item.label }}</h6>
</ng-template>
